import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DoubleArrow",
  "use": "DoubleArrow-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol viewBox=\"0 0 14 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"DoubleArrow\">\n<path d=\"M4 0L0 3.99H3V11H5V3.99H8L4 0ZM11 14.01V7H9V14.01H6L10 18L14 14.01H11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol